'use client';

import { usePathname } from 'next/navigation';
import Navbar from './Navbar/Navbar';

export default function ConditionalNavbar() {
  const pathname = usePathname();

  // Hide navbar on widget page
  if (pathname === '/widget') {
    return null;
  }

  return <Navbar />;
}
